import Core from '../../../../Core/Core';
import { createOutlineText } from '../../../../Utils/Utils';
import { ProgressBar } from '../../../Shared/ProgressBar';

export class MissionProgress extends ProgressBar {
    public curTotal: number;
    private readonly progressTxt: PIXI.Text;
    private showCurrent: boolean;

    constructor(target: number, showCurrent: boolean) {
        super();

        this.progressTxt = createOutlineText(
            '0/' + target.toString(10),
            new PIXI.Rectangle(0, 0, this.progressBar.width, this.progressBar.height),
            'Baloo',
            30,
            0,
            0xffffff,
            0x006073,
            5
        );
        this.progressTxt.anchor.set(0.5);
        this.progressTxt.x = this.progressBar.width * 0.5;
        this.progressTxt.y = this.progressBar.height * 0.425;
        this.showCurrent = showCurrent;
        this.scale.set(0.6, 0.7);
        this.addChild(this.progressTxt);
    }

    public showTimeCount(time: string) {
        if (this.curTotal !== 0) {
            this.updateProgress(0, 100);
        }
        this.progressTxt.text = time;
    }

    public updateProgress(progress: number, target: number, showCurrent: boolean = null) {
        const percentage = progress / target;
        this.progress = percentage;
        this.curTotal = percentage;
        this.showCurrent = showCurrent !== null ? showCurrent : this.showCurrent;
        if (percentage === 1) {
            this.progressTxt.text = Core.local.getText('Completed');
        } else {
            if (this.showCurrent) {
                this.progressTxt.text = progress.toString(10) + '/' + target.toString(10);
            } else {
                this.progressTxt.text = target.toString(10);
            }
        }
    }
}
